<div class="p-grid">
    <div class="p-col-12 page-header">{{resourceCategory}}</div>
    <div class="p-col-12 divider-header">
        <p-divider></p-divider>
    </div>
    <div class="p-col-12">
        <div class="p-grid">
            <div class="p-col-12 p-lg-2 p-md-2" *ngIf="canAddResource">
                <p-button styleClass="fullwidthbtn" label="New Resource" routerLink="/resource/new"></p-button>
            </div>
            <div class="p-col-12 p-lg-6 p-md-6" *ngIf="canAddResource"></div>
            <div class="p-col-12 p-lg-4 p-md-4">
                <div class="p-col-12">
                    <div class="p-grid">
                        <div class="p-col-8">
                            <input type="text" pInputText [(ngModel)]="searchterm" placeholder="Search Resources">
                        </div>
                        <div class="p-col-4">
                            <button pButton type="button" icon="pi pi-search" iconPos="left" (click)="SearchResources($event)"></button>
                        </div>
                    </div>                 
                </div>              
            </div>
        </div>
    <div class="p-col-12" *ngIf="resources" style="margin-top: -15px;">
        <div class="card">
            <div id="dataListWrapper">
                <p-dataView #dv [value]="resources" [paginator]="true" [rows]="5">                   
                    <ng-template let-resource pTemplate="listItem">
                        <div class="p-col-12">
                            <div class="object-list-item">
                                <div class="object-list-detail">
                                    <div class="p-grid">
                                        <div class="p-col-12">
                                            <div class="floatRight">
                                                <div class="p-col-6 p-lg-1 p-md-2" *ngIf="canEditResource">
                                                    <p-button routerLink="/resource/edit/{{resource.Id}}" icon="pi pi-pencil" label="Edit" class="p-button-text"></p-button>
                                                </div>
                                                <div class="p-col-6 p-lg-1 p-md-2" *ngIf="canDeleteResource">
                                                    <p-button (click)="deleteResource(resource)" icon="pi pi-trash" label="Delete" class="p-button-text"></p-button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="p-col-12 object-name">
                                            <span><strong>{{resource.Name}}</strong></span>
                                        </div>
                                        <div class="p-col-12">
                                            <div class="object-description"><b>{{resource.PostingUserName}}</b> posted on {{resource.PostedDate | date:'MM/dd/yyyy'}}</div>
                                            <div class="object-description" [innerHTML]="resource.Description"></div>
                                            <strong>Attachments:</strong>
                                            <div class="p-col-12">
                                                <p-table [value]="resource.Documents" dataKey="Id" [rows]="20" [responsive]="true"
                                                         [resizableColumns]="true">
                                                    <ng-template pTemplate="body" let-doc>
                                                        <tr>
                                                            <td>
                                                                <a class="hyperLink" (click)="OpenUrl(doc)">{{doc.Title}}</a>
                                                            </td>
                                                            <td>
                                                                <span [class]=" getIcon(doc) + ' fiv-size-md '"></span>
                                                            </td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </div>
                                    </div>                                 
                                </div>                              
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft"></ng-template>
                    <ng-template pTemplate="paginatorright">
                        {{resources != undefined ? resources.length : 0}} result(s).
                    </ng-template>
                </p-dataView>
            </div>
        </div>
    </div>
</div>
<p-confirmDialog header="Confirmation" key="DeleteResourceConfirmDialog" icon="pi pi-exclamation-triangle"></p-confirmDialog>
